import { subscribeToElectronTaskCreate } from './subscribe-to-electron-task-create';
import { subscribeToTaskCreationData } from './subscribe-to-task-creation-data';

export const initElectronCommunication = () => {
  const isTrustedElectronApp = navigator.userAgent.includes('GriplyDesktop');
  if (!isTrustedElectronApp) {
    return;
  }

  subscribeToElectronTaskCreate();
  subscribeToTaskCreationData();
};
